import React, { useEffect, useState } from 'react'
import { Breadcrumb } from '../../common/atoms'
import { STEPATHON_LEADERBOARD as headers } from '../../../constants/tableHeaders'
import { Table } from '../../common/molecules'
import { useHistory, useLocation } from 'react-router-dom'
import { StepathonApi } from '../../../services'
import { handleAppError } from '../../handlers'
import MemberListPageSchema from '../../../schemas/table/MemberListPageSchema'
import { SearchBar } from '../../tailwind/molecules'
import { dsButtonPrimary, joinButtonClasses } from '../../../utils/buttonStyles'

const MemberListPage = () => {
  let location = useLocation()
  let history = useHistory()
  let [state , setState] = useState({
    locationData : {},
    openModal : false,
    expandArrow : null,
    loading : true,
    memberLoading : false,
    MemberData : [],
    reUploadButton : '',
    id:''
  })
  const setSubState = (newState) => {
    setState(prevState => { return {...prevState, ...newState} })
  }
  let fetchMemberList = (data, term = '') =>{
    let id = data?.id
    console.log(term);
    StepathonApi.fetchMemberListPage(
       { id :  id, term : term},
       (resp) => {
        let MemberListData = resp.data.members
        setSubState({MemberData : MemberListData, reUploadButton : data.tag, loading : false})
       },
       (err) => {
        setSubState({loading : false}) 
        handleAppError(err);
       }
     );
   } 

  useEffect(()=>{
    setSubState({locationData:  location.state})
    fetchMemberList(location.state)
   },[location])

  let onSearchHandler = (value) =>{
    if (value !== undefined || value !== null){
      fetchMemberList(location.state, value)
    }
  }



  const navigateToUploadTeams =() =>{
      history.push({pathname : '/stepathon/member-upload', state : { stepathon_id : state.locationData.id, text: 're-upload'}})
  }


  return (
    <React.Fragment>
      <div className='flex flex-row justify-between'>
        <div>
          <Breadcrumb
            list={[
              { text: 'Engagement', link: '/stepathon' },
              { text: 'Stepathon', link: '/stepathon' },
              { text: 'View Members', link: '#' }
            ]}
            classes='mb-1'
          />
          <p className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0'>Members</p>
        </div>
        { state.reUploadButton === 'Yet to Start' &&
          <button
            type='button'
            onClick={navigateToUploadTeams}
            style={{height: '44px', width: '178px'}}
            className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6')}
          >
            Re-upload teams
          </button>
        }
      </div>
      <SearchBar
        classes='mb-4 h-12 mt-4' 
        closeIcon={true} 
        CloseIconHandler={(e) => onSearchHandler('')} 
        placeholder='Search by employee name, employee id and email id' 
        inputClasses={`px-3 rounded-md pt-4 pb-3 pl-10 text-base  placeholder-gray-100 leading-4 bg-white`}
        handler={(e) => onSearchHandler(e)}/>
      <Table
        headers={headers.individual_members}
        loading={state.loading}
        data={state.MemberData}
        name='table'
        headerClasses='pl-4 py-4'
        tableClasses='alternate_gray200_color'
        classes='rounded-md mt-6 mb-16 overflow-y-auto '
        tableschema={MemberListPageSchema}
        tableHeaderClasses='sticky top-0 z-10'
      />
    </React.Fragment>
  )
}

export default MemberListPage
